enum HorizontalAlignment {
	LEFT = 'align-left',
	RIGHT = 'align-right'
}

export default HorizontalAlignment;
